function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-InstanceCost {\n        fill: currentColor;\n        stroke: currentColor;\n        stroke-width: 0.2px;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic-instance-type",
  transform: "translate(0.1 0.102)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8990",
  "data-name": "Path 8990",
  className: "cls-InstanceCost",
  d: "M109.653,71.865a7,7,0,0,1,0-14,.389.389,0,0,1,.389.389v6.221h6.221a.389.389,0,0,1,.389.389A7.008,7.008,0,0,1,109.653,71.865Zm-.389-13.209a6.221,6.221,0,1,0,6.6,6.6h-6.209a.389.389,0,0,1-.389-.389Z",
  transform: "translate(-102.653 -57.051)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8991",
  "data-name": "Path 8991",
  className: "cls-InstanceCost",
  d: "M127.5,63.959h-4.865a.389.389,0,0,1-.389-.389V58.7a.39.39,0,0,1,.481-.379,6.961,6.961,0,0,1,5.152,5.152.389.389,0,0,1-.379.481Zm-4.475-.779h3.959a6.285,6.285,0,0,0-3.959-3.96Z",
  transform: "translate(-113.079 -58.315)"
}));

function SvgInstanceCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.015,
    height: 14.015,
    viewBox: "0 0 15.015 15.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstanceCost);
export default __webpack_public_path__ + "static/media/instance-cost.225b8ce2.svg";
export { ForwardRef as ReactComponent };